import React from "react";
import { UserSelectContainer } from "../user-select";
import { FilterDropdownProps } from "antd/lib/table/interface";

export const filterUser = ({ setSelectedKeys, confirm, clearFilters }: FilterDropdownProps) => (
  <UserSelectContainer
    onApplyFilter={(values: number[]) => {
      setSelectedKeys(values);
      confirm();
    }}
    onClearFilter={() => {
      clearFilters?.();
      confirm();
    }}
  />
);
